import type { IDataAccessor } from "@core/data-access";
import { AbstractAccessorService } from "@core/data-access";
import type { IResponse } from "@core/data-access/model";
import type { IWebsiteCurrencyRestService } from "./website-currency-rest";
import type { ICurrency } from "@modules/website/model/domain/currency";


export class WebsiteCurrencyRestService extends AbstractAccessorService<ICurrency> implements IWebsiteCurrencyRestService {
    public static readonly $inject: string[] = ["$accessor"];

    public readonly $name = "webSiteCurrencyRestService";

    constructor(public $accessor: IDataAccessor<ICurrency>) {
        super();
    }

    /**
     * @description: 
     * @param {string} usageScope(Frontend | Backend | EShop) 不传默认为Frontend
     */
    public getAll(usageScope?: "Frontend" | "Backend" | "EShop"): angular.IPromise<IResponse<Array<ICurrency>>> {
        return this.$accessor<Array<ICurrency>, any, string>(this.$name, "getAll", { 
            parameter: {
                usageScope: usageScope
            } 
        });
    }
}